//通过组件配置路由
import loadable from '../util/loadable'
const routes = [{
    path: '/passport/login',
    component: loadable(() => import('../component/registerAndLogin/login/index')) //卖家登录
}];
export default routes